// arr1 - is the basis of the order of two arrays
// arr2 - the array that will be sorted based on the arr1 order
export const sortArrays = (arr1, arr2) => {
  // Create a map to store the indices of elements in arr1
  const indexMap = {};
  arr1.forEach((val, index) => {
      indexMap[val] = index;
  });

  // Sort arr2 based on the indices of arr1
  arr2.sort((a, b) => {
      const indexA = indexMap[a];
      const indexB = indexMap[b];
      // If either value is not present in arr1, put it at the end
      if (indexA === undefined) return 1;
      if (indexB === undefined) return -1;
      return indexA - indexB;
  });

  return arr2;
}